import { Blocker } from "../stores/Blocker";
import { Cubby } from "../stores/Cubby";

export const makeBlockerOrReturnFalse = (
  cubby: Cubby,
  kind: string,
  uniqueExternalIdentifier: string
): boolean => {
  if (
    cubby.blockers.find(
      (blocker) => blocker.uniqueExternalIdentifier == uniqueExternalIdentifier
    )
  ) {
    return false;
  }
  cubby.blockers.push(
    new Blocker({
      uuid: Math.random().toString(36).substring(2, 10),
      kind: kind,
      uniqueExternalIdentifier: uniqueExternalIdentifier,
    })
  );
  return true;
};
